import { createSelector } from 'reselect';

const selectGlobalDBNAgentMappings = (state: any) => state.globalDBNAgentMappings;


export const selectGlobalDBNAgentMappingsCurrentItem = createSelector([selectGlobalDBNAgentMappings], (globalDBNAgentMappings) => globalDBNAgentMappings.current);

export const selectGlobalDBNAgentMappingsListItems = createSelector([selectGlobalDBNAgentMappings], (globalDBNAgentMappings) => globalDBNAgentMappings.list);

export const selectItemById = (itemId: any) =>
    createSelector(selectGlobalDBNAgentMappingsListItems, (list) => list.result.items.find((item: any) => item._id === itemId));

export const selectGlobalDBNAgentMappingsQueryItems = createSelector([selectGlobalDBNAgentMappings], (globalDBNAgentMappings) => globalDBNAgentMappings.query);

export const selectGlobalDBNAgentMappingsCreatedItem = createSelector([selectGlobalDBNAgentMappings], (globalDBNAgentMappings) => globalDBNAgentMappings.create);

export const selectGlobalDBNAgentMappingsUpdatedItem = createSelector([selectGlobalDBNAgentMappings], (globalDBNAgentMappings) => globalDBNAgentMappings.update);

export const selectGlobalDBNAgentMappingsReadItem = createSelector([selectGlobalDBNAgentMappings], (globalDBNAgentMappings) => globalDBNAgentMappings.read);

export const selectGlobalDBNAgentMappingsDeletedItem = createSelector([selectGlobalDBNAgentMappings], (globalDBNAgentMappings) => globalDBNAgentMappings.delete);

export const selectGlobalDBNAgentMappingsSearchedItems = createSelector([selectGlobalDBNAgentMappings], (globalDBNAgentMappings) => globalDBNAgentMappings.search);

export const selectGlobalDBNAgentMappingsItemsCount = createSelector([selectGlobalDBNAgentMappings], (globalDBNAgentMappings) => globalDBNAgentMappings.count);

export const selectGlobalDBNAgentMappingsItemsFilter = createSelector([selectGlobalDBNAgentMappings], (globalDBNAgentMappings) => globalDBNAgentMappings.filter);